import request from '@/utils/request'


// 查询激活码信息列表
export function listCode(query) {
  return request({
    url: '/active/code/list',
    method: 'get',
    params: query
  })
}

// 查询激活码信息分页
export function pageCode(query) {
  return request({
    url: '/active/code/page',
    method: 'get',
    params: query
  })
}

// 查询激活码信息详细
export function getCode(data) {
  return request({
    url: '/active/code/detail',
    method: 'get',
    params: data
  })
}

// 新增激活码信息
export function addCode(data) {
  return request({
    url: '/active/code/add',
    method: 'post',
    data: data
  })
}

// 修改激活码信息
export function updateCode(data) {
  return request({
    url: '/active/code/edit',
    method: 'post',
    data: data
  })
}

// 删除激活码信息
export function delCode(data) {
  return request({
    url: '/active/code/delete',
    method: 'post',
    data: data
  })
}
